module.exports = __webpack_public_path__ + "img/logoSlide3.594adbd6.png";